import React from 'react'
import { at } from 'lodash'
import { useField } from 'formik'
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@material-ui/core'

interface CheckboxFieldProps {
    className: string
    name: string
    value: string
    label: string
}

export default function CheckboxField(props: CheckboxFieldProps) {
    const { label, ...rest } = props
    const [field, meta, helper] = useField(props)
    const { setValue } = helper

    function _renderHelperText() {
        const [touched, error] = at(meta, 'touched', 'error')
        if (touched && error) {
            return <FormHelperText>{error}</FormHelperText>
        }
    }

    function _onChange(e: React.ChangeEvent<any>) {
        setValue(e.target.checked)
    }

    return (
        <FormControl {...rest}>
            <FormControlLabel
                value={field.checked}
                checked={field.checked}
                control={<Checkbox color="primary" {...field} onChange={_onChange} />}
                label={label}
            />
            {_renderHelperText()}
        </FormControl>
    )
}
